import React, { useState, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const SendInvitationModal = React.forwardRef((props, ref) => {
  const [formInputs, setFormInputs] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    if (props.show) {
      setFormInputs({
        name: props?.inquiryData?.customerName || "",
        email: "",
        message: "",
      });
    }
  }, [props.show, props?.inquiryData]);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formInputs.name.trim() || !formInputs.email.trim()) {
      return;
    }
    await props.onSubmit(formInputs);
    props.onHide();
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <i className="bi bi-envelope-at me-2"></i> Send Invitation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="space-y-4">
          <Row>
            <Col xs={12} md={6} lg={6} className="commLeftRightPadding mb-3">
              <InputField
                className="inputBox"
                label="Name"
                name="name"
                placeholder="Enter name"
                value={formInputs.name}
                onChange={onInputChange}
                required
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="commLeftRightPadding mb-3">
              <InputField
                className="inputBox"
                label="Email"
                name="email"
                placeholder="Enter email"
                value={formInputs.email}
                onChange={onInputChange}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={6} className="commLeftRightPadding mb-3">
              <InputField
                className="inputBox"
                label="Subject"
                name="subject"
                placeholder="Enter subject"
                value={formInputs.subject || ""}
                onChange={onInputChange}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="commLeftRightPadding mb-3">
              <TextAreaField
                className="inputBox"
                label="Message"
                name="message"
                placeholder="Enter your message"
                rows={4}
                value={formInputs.message}
                onChange={onInputChange}
              />
            </Col>
          </Row>

          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={!formInputs.name.trim() || !formInputs.email.trim()}
              >
                Send
              </button>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default SendInvitationModal;
